import connect from 'components/Shared/connect';
import {
  getQuantity,
  getSplashTextEnd,
  getSplashTextTop,
  getIsCampaign,
  getIsLowPrice,
  showDoorPrice,
  getProduct,
  getPricePure,
  getIsLoweredPrice,
  getIsPartialCampaign,
  getIsBundleSavings
} from 'views/ProductPage/selector';
import { Price as PriceProps } from 'models/Price';
import { QuantityProps } from 'components/Shared/Quantity/Quantity';
import { getConfigurator } from 'views/ProductPage/configurators/selector';
import { NO_ELEMENT, rm } from 'utils';
import { memo } from 'react';
import { LoadingStatus } from 'models/LoadingStatus';
import { CardPrice } from 'components/Shared/Price/themes/BGH/cardPrice';
import { ConfiguratorBase } from 'models/ConfiguratorBase';
import { DetailedProduct } from 'models/DetailedProduct';

const getDoorPriceInfo = ({ showDoorPrice, price }: GetDoorPriceInfoProps): DoorPriceInfo => ({
  pricePerDoor: showDoorPrice ? price.listPrice : undefined,
  pricePerDoorUnit: showDoorPrice ? rm('product_configurator_slidingdoor_unit') : '',
  doorPrice: showDoorPrice ? price.lowestPossiblePrice : price.presentationPrice
});

const isLoading = (_: ProductInfoHeaderProps, curr: ProductInfoHeaderProps) =>
  curr.status === LoadingStatus.Fetching;

interface ProductInfoHeaderProps {
  isCampaign: boolean;
  isPartialCampaign: boolean;
  isBundleSavings: boolean;
  isLowPrice: boolean;
  isLoweredPrice: boolean;
  price: PriceProps;
  quantity: QuantityProps & { salesUnit?: string; salesQuantity?: number };
  splashTextEnd?: string;
  splashTextTop?: string;
  splashTextMiddle?: string;
  inDrawer?: boolean;
  showDoorPrice?: boolean;
  status?: number;
  page?: 'productpage' | 'productpageMobile';
  isFamily?: boolean;
}

const ProductPriceComponent = memo(
  ({
    price,
    splashTextEnd,
    splashTextTop,
    isCampaign,
    isPartialCampaign,
    isBundleSavings,
    isLowPrice,
    isLoweredPrice,
    quantity,
    showDoorPrice,
    page,
    isFamily
  }: ProductInfoHeaderProps) => {
    const { doorPrice, pricePerDoor, pricePerDoorUnit } = getDoorPriceInfo({
      showDoorPrice,
      price
    });

    const updatedPrice = {
      ...price,
      presentationPrice: doorPrice ? doorPrice : 0
    };

    return (
      <>
        <CardPrice
          isCampaign={isCampaign}
          isPartialCampaign={isPartialCampaign}
          isBundleSavings={isBundleSavings}
          isLowPrice={isLowPrice}
          isLoweredPrice={isLoweredPrice}
          price={updatedPrice}
          splashTextEnd={splashTextEnd}
          splashTextTop={splashTextTop}
          hasMinimumQuantityRequirement={quantity.lowest > 1}
          page={page}
          quantityUnit={quantity.unit}
          salesUnit={quantity.salesUnit}
          salesQuantity={quantity.salesQuantity}
          partPrice={pricePerDoor}
          partPriceUnit={pricePerDoorUnit}
          isFamily={isFamily}
        />
      </>
    );
  },
  isLoading
);

interface GetDoorPriceInfoProps {
  showDoorPrice?: boolean;
  price: PriceProps;
}

interface DoorPriceInfo {
  pricePerDoor?: number;
  pricePerDoorUnit?: string;
  doorPrice?: number;
}

interface OwnProps {
  isMobile?: boolean;
  showDoorPrice?: boolean;
}

export const PureProductPrice = ({ isMobile, ...props }: ProductInfoHeaderProps & OwnProps) => {
  if (props.price.hiddenPrice) {
    return NO_ELEMENT;
  }

  const page = isMobile ? 'productpageMobile' : 'productpage';

  return <ProductPriceComponent page={page} {...props} />;
};

interface StateProps {
  config: ConfiguratorBase;
  product: DetailedProduct;
}
export const ProductPrice = connect<ProductInfoHeaderProps, OwnProps, StateProps>(
  ({ currentPage }) => ({
    quantity: getQuantity(currentPage),
    splashTextEnd: getSplashTextEnd(currentPage),
    splashTextTop: getSplashTextTop(currentPage),
    isCampaign: getIsCampaign(currentPage),
    isPartialCampaign: getIsPartialCampaign(currentPage),
    isBundleSavings: getIsBundleSavings(currentPage),
    isLowPrice: getIsLowPrice(currentPage),
    isLoweredPrice: getIsLoweredPrice(currentPage),
    config: getConfigurator(currentPage),
    product: getProduct(currentPage),
    showDoorPrice: showDoorPrice(currentPage),
    status: currentPage.status
  }),
  undefined,
  ({ config, product, ...state }, dispatch, props) => ({
    ...state,
    ...dispatch,
    ...props,
    config,
    price: getPricePure({ product, configurator: config }),
    isFamily: product.isFamily
  })
)(PureProductPrice);
